import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import isNil from 'lodash/isNil';
import noop from 'lodash/noop';
function getCount(count) {
    if (typeof count === 'function') {
        return count();
    }
    return count;
}
function defaultRenderer(props) {
    const { text } = props;
    if (text) {
        return text;
    }
}
const Count = function Count(props) {
    const { count, overflowCount, prefixCls, renderer = defaultRenderer, asyncCount = noop } = props;
    const number = getCount(count);
    useEffect(() => {
        if (count !== number) {
            asyncCount();
        }
    }, [number]);
    const renderedText = renderer({
        text: overflowCount && number && number > overflowCount ? `${overflowCount}+` : number,
        count: number,
        overflowCount,
    });
    if (!isNil(renderedText)) {
        return (React.createElement("span", { className: `${prefixCls}-tab-count` }, renderedText));
    }
    return null;
};
Count.displayName = 'Count';
export default observer(Count);
